import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useProjectsState,
	useIssueTypesState,
	useMappingsActions,
} from '../providers/BulkConfigureContextProvider.tsx';
import { useBulkCreateLoggingEvents } from '../utils/useBulkCreateLoggingEvents.tsx';

import { fetchWorkflowValidators } from './apiUtils.ts';

export const FETCH_WORKFLOW_VALIDATORS = 'fetch-workflow-validators';

export const useGetAllWorkflowValidators = () => {
	const { logRequestFailed } = useBulkCreateLoggingEvents();
	const { selectedAvailableSite } = useAvailableSitesState();
	const { selectedProject } = useProjectsState();
	const { selectedIssueType } = useIssueTypesState();
	const { setWorkflowValidators } = useMappingsActions();

	useEffect(() => {
		const cloudId = selectedAvailableSite?.cloudId;
		const projectId = selectedProject?.id;
		const issueTypeId = selectedIssueType?.id;
		if (!cloudId || !projectId || !issueTypeId) {
			return;
		}
		const getValidators = async () => {
			try {
				const data = await fetchWorkflowValidators({
					cloudId,
					projectId,
					issueTypeId,
				});
				setWorkflowValidators(data ?? null);
			} catch (error: Error | unknown) {
				logRequestFailed({
					requestName: FETCH_WORKFLOW_VALIDATORS,
					errorMessage: (error as Error).message,
				});
			}
		};

		void getValidators();
	}, [
		selectedAvailableSite,
		selectedProject,
		selectedIssueType,
		logRequestFailed,
		setWorkflowValidators,
	]);
};
